const paths = ['/edition/preview'];

export default defineNuxtRouteMiddleware((to, from) => {
  if (paths.includes(from?.path) && !paths.includes(to?.path)) {
    return abortNavigation();
  }
});
